export default "__VITE_ASSET__CzcIsQrS__"